module.exports = __webpack_public_path__ + "img/print-white.8eb81074.svg";